// @flow
import { FormattedMessage } from 'react-intl';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import React from 'react';
import styles from './Links.module.scss';

type Props = {|
    whiteLabelName: string,
    year: number,
|};

const Links = (props: Props) => {
    const { whiteLabelName, year } = props;

    return (
        <div className={styles.links}>
            <div className={styles.linksInner}>
                <div className={styles.linksUpper}>
                    <span className={styles.name}>
                        <FormattedMessage
                            id="powered_by"
                            values={{
                                name: whiteLabelName,
                                onlineAuctions: (
                                    <Link className={styles.blackLink} to="https://www.liveauctioneers.com">
                                        <FormattedMessage id="onlineAuctions" />
                                    </Link>
                                ),
                            }}
                        />
                    </span>
                    <Link to="https://www.liveauctioneers.com/">
                        <img alt="liveauctioneers" src="https://p1.liveauctioneers.com/dist/images/logo.svg" />
                    </Link>
                </div>
                <div className={styles.linksLower}>
                    <span className={styles.copyright}>
                        <FormattedMessage
                            id="copyright_whitelabel"
                            values={{
                                privacy: (
                                    <Link route to="/privacy">
                                        <FormattedMessage id="privacy" />
                                    </Link>
                                ),
                                terms: (
                                    <Link route to="/termsandconditions">
                                        <FormattedMessage id="terms" />
                                    </Link>
                                ),
                                year,
                            }}
                        />
                    </span>
                </div>
            </div>
        </div>
    );
};

export default React.memo<Props>(Links);
